import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderNotificationsSummary: build.query<
      GetV2ProviderNotificationsSummaryApiResponse,
      GetV2ProviderNotificationsSummaryApiArg
    >({
      query: () => ({ url: `/v2/provider/notifications/summary` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderNotificationsSummaryApiResponse =
  /** status 200 OK */ NotificationSummaryResponse;
export type GetV2ProviderNotificationsSummaryApiArg = void;
export type NotificationCategory =
  | "note_queues"
  | "prescriptions"
  | "scheduling";
export type NotificationSummaryItem = {
  /** Category for grouping (e.g. note_queues) */
  category: NotificationCategory;
  /** Number of items requiring attention */
  count: number;
  /** Unique key within category (e.g. cosign_queue, edits_requested) */
  key: string;
  /** Human-readable description */
  label: string;
};
export type NotificationSummaryResponse = {
  /** Individual notification counters */
  items?: NotificationSummaryItem[];
  /** Sum of all counts for a single badge total */
  total_count?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
